import { useCallback, useContext } from "react";
import type { User } from "../core/Analytics";
import { AnalyticsContext } from "../core/AnalyticsContext";

export const useIdentify = () => {
  const analytics = useContext(AnalyticsContext);
  return useCallback(
    async (user: User) => {
      await analytics.identify(user);
    },
    [analytics]
  );
};
